export default __webpack_public_path__ + "static/media/back.5fa83d43.svg";